export const UNILUMIN_INTERNAL_EMAIL_DOMAIN = '@unilumin.com';

export function isUniluminInternalEmail(email?: string | null): boolean {
  return (email || '').trim().toLowerCase().endsWith(UNILUMIN_INTERNAL_EMAIL_DOMAIN);
}

export function deriveExternalUserFlag(
  email?: string | null,
  storedIsExternal?: boolean | null,
): boolean {
  const normalizedEmail = (email || '').trim();
  if (normalizedEmail) {
    return !isUniluminInternalEmail(normalizedEmail);
  }
  return storedIsExternal === true;
}
